import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_COMMISSION_REPORT } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const commissionReport = {
  namespaced: true,
  state: buildInitialState({
    commissionReportItems: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    clearCommissionReportItems: (state) => {
      state.commissionReportItems = []
    },
    setCommissionReportItems: (state, commissionReportItems) => {
      state.commissionReportItems = commissionReportItems
    }
  },
  actions: {
    getCommissionReportItems: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting commission data, please wait...' })
      return api.doGet({ path: PATH_COMMISSION_REPORT, parameters: filters })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          commit('setCommissionReportItems', data)
          hideProgressModal({ dispatch })
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to get commission data')
        })
    },
    getCommissionReportWithFilters: ({ dispatch, rootGetters }) => {
      return dispatch('getCommissionReportItems', { ...rootGetters['commissionReportFilters/getSearchObject'] })
    }
  }
}

export default commissionReport
